export enum AgencyInfoModalKeys {
  companyLogoLink = 'companyLogoLink',
  primaryEmailAddress = 'primaryEmailAddress',
  primaryPhoneNumber = 'primaryPhoneNumber',
  primaryShippingAddress = 'primaryShippingAddress',
  primaryBillingAddress = 'primaryBillingAddress',
}
